import { extend } from 'flarum/extend';
import Dropdown from 'flarum/components/Dropdown';

export default () => {
  app.initializers.add('categories-sidebar-extension', () => {
        extend(Dropdown.prototype, 'view', function(vdom) {
            const children = vdom?.children; 

            if (vdom.attrs.className && vdom.attrs.className.indexOf('App-titleControl') !== -1 && vdom.attrs.className.indexOf('itemCount14') !== -1) {
                // Clone the entire original dropdown (including the button) for mobile view and tablet view
                const originalDropdown = Object.assign({}, vdom, { attrs: Object.assign({}, vdom.attrs, { className: vdom.attrs.className + ' original-dropdown' }) });    
            
                let firstThreeLinks = [];

                children.forEach(child => {
                    if (child.attrs.className && child.attrs.className.indexOf('dropdown-menu') !== -1) {
                        firstThreeLinks = child.children.slice(0, 3);

                        // Desktop view, split the sidebar list into two groups
                        const group1 = child.children.slice(0, 2);
                        const group2 = child.children.slice(2);

                        // Create two new ul so that we could add borders
                        const ul1 = m('ul', { class: 'Dropdown-menu modified-dropdown' }, group1);
                        const ul2 = m('ul', { class: 'Dropdown-menu modified-dropdown' }, group2);

                        vdom.children =  [originalDropdown, ul1, ul2];
                    }
                });

                // create 3 tabs link for tablet view
                const tabLinks = firstThreeLinks.map(li => 
                    m('div', { class: 'hasIcon custom-item' }, li.children[0])
                );

                vdom.children = [...tabLinks, ...vdom.children];
            }

            // Add category-listItem class to each category sub link
            children?.forEach(child => {
                if (child.attrs.className?.indexOf('dropdown-menu') !== -1) {
                    child.children.filter(child => child.attrs.className && child.attrs.className.indexOf('tag') !== -1)
                        .map(child => child.attrs.className = child.attrs.className + ' category-listItem');
                }
            });
        });
    });
}
